module.exports = __webpack_public_path__ + "img/ic-eye-close.dc679305.svg";